// The adviser pages all use the same hero photo; only the copy differs.
// Spread this into each adviser hero section below.
const ADVISER_HERO_IMAGES = {
  src: 'old_mutual/homepage/hero_bar/advisers/1440.svg',
  landscapeSrc: 'old_mutual/homepage/hero_bar/advisers/1440.svg',
  mobileSrc: 'old_mutual/homepage/hero_bar/advisers/360.svg',
  iPadMiniSrc: 'old_mutual/homepage/hero_bar/advisers/960.svg',
  srcset: [
    { url: 'old_mutual/homepage/hero_bar/advisers/1440.svg', width: '1440w' },
    { url: 'old_mutual/homepage/hero_bar/advisers/1280.svg', width: '1280w' },
    { url: 'old_mutual/homepage/hero_bar/advisers/1024.svg', width: '1024w' },
    { url: 'old_mutual/homepage/hero_bar/advisers/960.svg', width: '960w' },
    { url: 'old_mutual/homepage/hero_bar/advisers/840.svg', width: '840w' },
    { url: 'old_mutual/homepage/hero_bar/advisers/720.svg', width: '720w' },
    { url: 'old_mutual/homepage/hero_bar/advisers/600.svg', width: '600w' },
    { url: 'old_mutual/homepage/hero_bar/advisers/360.svg', width: '430w' },
  ],
  sizes: `
            (max-width: 430px) 430px,
            (max-width: 600px) 600px,
            (max-width: 720px) 720px,
            (max-width: 840px) 840px,
            (max-width: 960px) 960px,
            (max-width: 1024px) 1024px,
            (max-width: 1280px) 1280px,
            1440px
          `,
  alt: '',
  buttonText: '',
  buttonLink: '',
};

export default {
  brand: 'oldmutual',
  name: 'Old Mutual Will',
  contactEmail: 'support@oldmutualwill.co.za',
  contactTelNumber: '021 753 3248',
  contactAddress: 'Mutualpark, \nJan Smuts Drive, \nPinelands, 7405',
  contactAddressRedesign: 'Mutualpark, \nJan Smuts Drive, \nPinelands, \n7405',
  estateAssistEnabled: true,
  overviewPageTitle: "Old Mutual's Online Will Service",
  overviewPartnershipTitle: '',
  colors: {
    primary: '#006437',
    secondary: '#8dc63f',
    tertiary: '#ED0080',
    primaryAlpha: 'rgba(0, 150, 119, 0.10)',
    'secondary-highlighted-font': '#000000',
    'secondary-button-font': '#000000',
    leftPanelGreen: '#009677',
    leftPanelIconGrey: '#DFE2EF',
    leftPanelOrange: '#FF9800',
  },
  images: {
    homepage: {
      heroBarSourceSets: [
        // {
        //   src: 'old_mutual/homepage/hero_bar/home/3/1440.svg',
        //   landscapeSrc: 'old_mutual/homepage/hero_bar/home/3/1440.svg',
        //   mobileSrc: 'old_mutual/homepage/hero_bar/home/3/360.svg',
        //   iPadMiniSrc: 'old_mutual/homepage/hero_bar/home/3/960.svg',
        //   srcset: [
        //     {
        //       url: 'old_mutual/homepage/hero_bar/home/3/1440.svg',
        //       width: '1440w',
        //     },
        //     {
        //       url: 'old_mutual/homepage/hero_bar/home/3/1280.svg',
        //       width: '1280w',
        //     },
        //     {
        //       url: 'old_mutual/homepage/hero_bar/home/3/1024.svg',
        //       width: '1024w',
        //     },
        //     {
        //       url: 'old_mutual/homepage/hero_bar/home/3/960.svg',
        //       width: '960w',
        //     },
        //     {
        //       url: 'old_mutual/homepage/hero_bar/home/3/840.svg',
        //       width: '840w',
        //     },
        //     {
        //       url: 'old_mutual/homepage/hero_bar/home/3/720.svg',
        //       width: '720w',
        //     },
        //     {
        //       url: 'old_mutual/homepage/hero_bar/home/3/600.svg',
        //       width: '600w',
        //     },
        //     {
        //       url: 'old_mutual/homepage/hero_bar/home/3/360.svg',
        //       width: '430w',
        //     },
        //   ],
        //   sizes: `
        //     (max-width: 430px) 430px,
        //     (max-width: 600px) 600px,
        //     (max-width: 720px) 720px,
        //     (max-width: 840px) 840px,
        //     (max-width: 960px) 960px,
        //     (max-width: 1024px) 1024px,
        //     (max-width: 1280px) 1280px,
        //     1440px
        //   `,
        //   alt: 'Old Mutual Will',
        //   boldTitle: null,
        //   title: `Your Children. Your Assets. Your Legacy.`,
        //   subtitle: `Why leave the future to chance? Create your Will today and protect what matters most.`,
        //   disclaimer: '',
        //   buttonText: 'Get Started',
        //   buttonLink: 'SignUp',
        //   smallText:
        //     'Get your will in English, Afrikaans, isiZulu, isiXhosa or Sepedi',
        // },
        {
          src: 'old_mutual/homepage/hero_bar/home/1/1440.svg',
          landscapeSrc: 'old_mutual/homepage/hero_bar/home/1/1440.svg',
          mobileSrc: 'old_mutual/homepage/hero_bar/home/1/360.svg',
          iPadMiniSrc: 'old_mutual/homepage/hero_bar/home/1/960.svg',
          srcset: [
            {
              url: 'old_mutual/homepage/hero_bar/home/1/1440.svg',
              width: '1440w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/1280.svg',
              width: '1280w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/1024.svg',
              width: '1024w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/960.svg',
              width: '960w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/840.svg',
              width: '840w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/720.svg',
              width: '720w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/600.svg',
              width: '600w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/360.svg',
              width: '430w',
            },
          ],
          sizes: `
            (max-width: 430px) 430px,
            (max-width: 600px) 600px,
            (max-width: 720px) 720px,
            (max-width: 840px) 840px,
            (max-width: 960px) 960px,
            (max-width: 1024px) 1024px,
            (max-width: 1280px) 1280px,
            1440px
          `,
          alt: 'Old Mutual Will',
          boldTitle: 'Creating a will',
          title: `shouldn't be overwhelming`,
          subtitle: `Our straightforward process makes creating your will easier, securing the future of your loved ones.`,
          disclaimer: '',
          buttonText: 'Get Started',
          buttonLink: 'SignUp',
          smallText:
            'Get your will in English, Afrikaans, isiZulu, isiXhosa or Sepedi',
        },
        {
          src: 'old_mutual/homepage/hero_bar/home/6/1440.svg',
          landscapeSrc: 'old_mutual/homepage/hero_bar/home/6/1440.svg',
          mobileSrc: 'old_mutual/homepage/hero_bar/home/6/360.svg',
          iPadMiniSrc: 'old_mutual/homepage/hero_bar/home/6/960.svg',
          srcset: [
            {
              url: 'old_mutual/homepage/hero_bar/home/6/1440.svg',
              width: '1440w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/6/1280.svg',
              width: '1280w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/6/1024.svg',
              width: '1024w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/6/960.svg',
              width: '960w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/6/840.svg',
              width: '840w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/6/720.svg',
              width: '720w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/6/600.svg',
              width: '600w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/6/360.svg',
              width: '430w',
            },
          ],
          sizes: `
            (max-width: 430px) 430px, 
            (max-width: 600px) 600px,
            (max-width: 720px) 720px,
            (max-width: 840px) 840px,
            (max-width: 960px) 960px,
            (max-width: 1024px) 1024px,
            (max-width: 1280px) 1280px,
            1440px
          `,
          alt: 'Old Mutual Will',
          boldTitle: '',
          title: `Your children. Your assets. Your legacy`,
          subtitle: `Create your Will today. Because without a Will, it's just a wish.`,
          disclaimer: '',
          buttonText: 'Get Started',
          buttonLink: 'SignUp',
        },
        {
          src: 'old_mutual/homepage/hero_bar/home/5/1440.svg',
          landscapeSrc: 'old_mutual/homepage/hero_bar/home/5/1440.svg',
          mobileSrc: 'old_mutual/homepage/hero_bar/home/5/360.svg',
          iPadMiniSrc: 'old_mutual/homepage/hero_bar/home/5/960.svg',
          srcset: [
            {
              url: 'old_mutual/homepage/hero_bar/home/5/1440.svg',
              width: '1440w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/5/1280.svg',
              width: '1280w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/5/1024.svg',
              width: '1024w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/5/960.svg',
              width: '960w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/5/840.svg',
              width: '840w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/5/720.svg',
              width: '720w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/5/600.svg',
              width: '600w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/5/360.svg',
              width: '430w',
            },
          ],
          sizes: `
            (max-width: 430px) 430px,
            (max-width: 600px) 600px,
            (max-width: 720px) 720px,
            (max-width: 840px) 840px,
            (max-width: 960px) 960px,
            (max-width: 1024px) 1024px,
            (max-width: 1280px) 1280px,
            1440px
          `,
          alt: 'Old Mutual Will',
          boldTitle: 'home language',
          trailingBold: true,
          title: `Get your will in your`,
          subtitle: `Available in English, Afrikaans, isiZulu, isiXhosa or Sepedi`,
          disclaimer: '',
          buttonText: 'Get Started',
          buttonLink: 'SignUp',
        },
      ],
    },
    home1: {
      heroBarSourceSets: [
        // {
        //   src: "old_mutual/homepage/hero_bar/home/3/1440.svg",
        //   landscapeSrc: "old_mutual/homepage/hero_bar/home/3/1440.svg",
        //   mobileSrc: "old_mutual/homepage/hero_bar/home/3/360.svg",
        //   iPadMiniSrc: "old_mutual/homepage/hero_bar/home/3/960.svg",
        //   srcset: [
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/1440.svg",
        //       width: "1440w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/1280.svg",
        //       width: "1280w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/1024.svg",
        //       width: "1024w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/960.svg",
        //       width: "960w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/840.svg",
        //       width: "840w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/720.svg",
        //       width: "720w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/600.svg",
        //       width: "600w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/360.svg",
        //       width: "430w",
        //     },
        //   ],
        //   sizes: `
        //     (max-width: 430px) 430px,
        //     (max-width: 600px) 600px,
        //     (max-width: 720px) 720px,
        //     (max-width: 840px) 840px,
        //     (max-width: 960px) 960px,
        //     (max-width: 1024px) 1024px,
        //     (max-width: 1280px) 1280px,
        //     1440px
        //   `,
        //   alt: "Old Mutual Will",
        //   boldTitle: "Create your will online",
        //   title: `with our expert-guided process`,
        //   subtitle: `Create your will online in as litte as 25 minutes`,
        //   disclaimer: "",
        //   buttonText: "START YOUR FREE WILL",
        //   buttonLink: "SignUp",
        // },
        {
          src: 'old_mutual/homepage/hero_bar/home/1/1440.svg',
          landscapeSrc: 'old_mutual/homepage/hero_bar/home/1/1440.svg',
          mobileSrc: 'old_mutual/homepage/hero_bar/home/1/360.svg',
          iPadMiniSrc: 'old_mutual/homepage/hero_bar/home/1/960.svg',
          srcset: [
            {
              url: 'old_mutual/homepage/hero_bar/home/1/1440.svg',
              width: '1440w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/1280.svg',
              width: '1280w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/1024.svg',
              width: '1024w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/960.svg',
              width: '960w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/840.svg',
              width: '840w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/720.svg',
              width: '720w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/600.svg',
              width: '600w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/360.svg',
              width: '430w',
            },
          ],
          sizes: `
            (max-width: 430px) 430px,
            (max-width: 600px) 600px,
            (max-width: 720px) 720px,
            (max-width: 840px) 840px,
            (max-width: 960px) 960px,
            (max-width: 1024px) 1024px,
            (max-width: 1280px) 1280px,
            1440px
          `,
          alt: 'Old Mutual Will',
          boldTitle: 'Protect Your Legacy, Family, and Wishes',
          title: ``,
          subtitle: `Create your will online in as little as 25 minutes`,
          disclaimer: '',
          buttonText: 'START YOUR FREE WILL',
          buttonLink: 'SignUp',
        },
        // {
        //   src: "old_mutual/homepage/hero_bar/home/2/1440.svg",
        //   landscapeSrc: "old_mutual/homepage/hero_bar/home/2/1440.svg",
        //   mobileSrc: "old_mutual/homepage/hero_bar/home/2/360.svg",
        //   iPadMiniSrc: "old_mutual/homepage/hero_bar/home/2/960.svg",
        //   srcset: [
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/1440.svg",
        //       width: "1440w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/1280.svg",
        //       width: "1280w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/1024.svg",
        //       width: "1024w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/960.svg",
        //       width: "960w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/840.svg",
        //       width: "840w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/720.svg",
        //       width: "720w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/600.svg",
        //       width: "600w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/360.svg",
        //       width: "430w",
        //     },
        //   ],
        //   sizes: `
        //     (max-width: 430px) 430px,
        //     (max-width: 600px) 600px,
        //     (max-width: 720px) 720px,
        //     (max-width: 840px) 840px,
        //     (max-width: 960px) 960px,
        //     (max-width: 1024px) 1024px,
        //     (max-width: 1280px) 1280px,
        //     1440px
        //   `,
        //   alt: "Old Mutual Will",
        //   boldTitle: "Create your will online",
        //   title: `with our expert-guided process`,
        //   subtitle: `Create your will online in as litte as 25 minutes`,
        //   disclaimer: "",
        //   buttonText: "START YOUR FREE WILL",
        //   buttonLink: "SignUp",
        // },
      ],
    },
    home2: {
      heroBarSourceSets: [
        // {
        //   src: "old_mutual/homepage/hero_bar/home/3/1440.svg",
        //   landscapeSrc: "old_mutual/homepage/hero_bar/home/3/1440.svg",
        //   mobileSrc: "old_mutual/homepage/hero_bar/home/3/360.svg",
        //   iPadMiniSrc: "old_mutual/homepage/hero_bar/home/3/960.svg",
        //   srcset: [
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/1440.svg",
        //       width: "1440w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/1280.svg",
        //       width: "1280w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/1024.svg",
        //       width: "1024w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/960.svg",
        //       width: "960w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/840.svg",
        //       width: "840w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/720.svg",
        //       width: "720w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/600.svg",
        //       width: "600w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/360.svg",
        //       width: "430w",
        //     },
        //   ],
        //   sizes: `
        //     (max-width: 430px) 430px,
        //     (max-width: 600px) 600px,
        //     (max-width: 720px) 720px,
        //     (max-width: 840px) 840px,
        //     (max-width: 960px) 960px,
        //     (max-width: 1024px) 1024px,
        //     (max-width: 1280px) 1280px,
        //     1440px
        //   `,
        //   alt: "Old Mutual Will",
        //   boldTitle: "Create your will online",
        //   title: `with our expert-guided process`,
        //   subtitle: `Create your will online in as litte as 25 minutes`,
        //   disclaimer: "",
        //   buttonText: "START YOUR FREE WILL",
        //   buttonLink: "SignUp",
        // },
        {
          src: 'old_mutual/homepage/hero_bar/home/1/1440.svg',
          landscapeSrc: 'old_mutual/homepage/hero_bar/home/1/1440.svg',
          mobileSrc: 'old_mutual/homepage/hero_bar/home/1/360.svg',
          iPadMiniSrc: 'old_mutual/homepage/hero_bar/home/1/960.svg',
          srcset: [
            {
              url: 'old_mutual/homepage/hero_bar/home/1/1440.svg',
              width: '1440w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/1280.svg',
              width: '1280w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/1024.svg',
              width: '1024w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/960.svg',
              width: '960w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/840.svg',
              width: '840w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/720.svg',
              width: '720w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/600.svg',
              width: '600w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/360.svg',
              width: '430w',
            },
          ],
          sizes: `
            (max-width: 430px) 430px,
            (max-width: 600px) 600px,
            (max-width: 720px) 720px,
            (max-width: 840px) 840px,
            (max-width: 960px) 960px,
            (max-width: 1024px) 1024px,
            (max-width: 1280px) 1280px,
            1440px
          `,
          alt: 'Old Mutual Will',
          boldTitle: "It's free.",
          title: `Create your will online.`,
          subtitle: `No lawyer needed. No paperwork. Your legally valid will, backed by Old Mutual.`,
          disclaimer: '',
          buttonText: 'START YOUR FREE WILL',
          buttonLink: 'SignUp',
        },
        // {
        //   src: "old_mutual/homepage/hero_bar/home/2/1440.svg",
        //   landscapeSrc: "old_mutual/homepage/hero_bar/home/2/1440.svg",
        //   mobileSrc: "old_mutual/homepage/hero_bar/home/2/360.svg",
        //   iPadMiniSrc: "old_mutual/homepage/hero_bar/home/2/960.svg",
        //   srcset: [
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/1440.svg",
        //       width: "1440w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/1280.svg",
        //       width: "1280w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/1024.svg",
        //       width: "1024w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/960.svg",
        //       width: "960w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/840.svg",
        //       width: "840w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/720.svg",
        //       width: "720w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/600.svg",
        //       width: "600w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/360.svg",
        //       width: "430w",
        //     },
        //   ],
        //   sizes: `
        //     (max-width: 430px) 430px,
        //     (max-width: 600px) 600px,
        //     (max-width: 720px) 720px,
        //     (max-width: 840px) 840px,
        //     (max-width: 960px) 960px,
        //     (max-width: 1024px) 1024px,
        //     (max-width: 1280px) 1280px,
        //     1440px
        //   `,
        //   alt: "Old Mutual Will",
        //   boldTitle: "",
        //   title: `Join the 30% of South Africans who have a will`,
        //   subtitle: `Create your will online today to ensure your wishes can be honoured and your loved ones are protected.`,
        //   disclaimer: "",
        //   buttonText: "GET STARTED",
        //   buttonLink: "SignUp",
        // },
      ],
    },
    home3: {
      heroBarSourceSets: [
        // {
        //   src: "old_mutual/homepage/hero_bar/home/3/1440.svg",
        //   landscapeSrc: "old_mutual/homepage/hero_bar/home/3/1440.svg",
        //   mobileSrc: "old_mutual/homepage/hero_bar/home/3/360.svg",
        //   iPadMiniSrc: "old_mutual/homepage/hero_bar/home/3/960.svg",
        //   srcset: [
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/1440.svg",
        //       width: "1440w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/1280.svg",
        //       width: "1280w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/1024.svg",
        //       width: "1024w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/960.svg",
        //       width: "960w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/840.svg",
        //       width: "840w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/720.svg",
        //       width: "720w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/600.svg",
        //       width: "600w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/360.svg",
        //       width: "430w",
        //     },
        //   ],
        //   sizes: `
        //     (max-width: 430px) 430px,
        //     (max-width: 600px) 600px,
        //     (max-width: 720px) 720px,
        //     (max-width: 840px) 840px,
        //     (max-width: 960px) 960px,
        //     (max-width: 1024px) 1024px,
        //     (max-width: 1280px) 1280px,
        //     1440px
        //   `,
        //   alt: "Old Mutual Will",
        //   boldTitle: "Create your will online",
        //   title: `with our expert-guided process`,
        //   subtitle: `Create your will online in as litte as 25 minutes`,
        //   disclaimer: "",
        //   buttonText: "START YOUR FREE WILL",
        //   buttonLink: "SignUp",
        // },
        {
          src: 'old_mutual/homepage/hero_bar/home/1/1440.svg',
          landscapeSrc: 'old_mutual/homepage/hero_bar/home/1/1440.svg',
          mobileSrc: 'old_mutual/homepage/hero_bar/home/1/360.svg',
          iPadMiniSrc: 'old_mutual/homepage/hero_bar/home/1/960.svg',
          srcset: [
            {
              url: 'old_mutual/homepage/hero_bar/home/1/1440.svg',
              width: '1440w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/1280.svg',
              width: '1280w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/1024.svg',
              width: '1024w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/960.svg',
              width: '960w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/840.svg',
              width: '840w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/720.svg',
              width: '720w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/600.svg',
              width: '600w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/360.svg',
              width: '430w',
            },
          ],
          sizes: `
            (max-width: 430px) 430px,
            (max-width: 600px) 600px,
            (max-width: 720px) 720px,
            (max-width: 840px) 840px,
            (max-width: 960px) 960px,
            (max-width: 1024px) 1024px,
            (max-width: 1280px) 1280px,
            1440px
          `,
          alt: 'Old Mutual Will',
          boldTitle: 'Create your will online',
          title: `with our expert-guided process`,
          subtitle: `It’s legally compliant and free `,
          disclaimer: '',
          buttonText: 'START YOUR FREE WILL',
          buttonLink: 'SignUp',
        },
        // {
        //   src: "old_mutual/homepage/hero_bar/home/2/1440.svg",
        //   landscapeSrc: "old_mutual/homepage/hero_bar/home/2/1440.svg",
        //   mobileSrc: "old_mutual/homepage/hero_bar/home/2/360.svg",
        //   iPadMiniSrc: "old_mutual/homepage/hero_bar/home/2/960.svg",
        //   srcset: [
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/1440.svg",
        //       width: "1440w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/1280.svg",
        //       width: "1280w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/1024.svg",
        //       width: "1024w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/960.svg",
        //       width: "960w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/840.svg",
        //       width: "840w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/720.svg",
        //       width: "720w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/600.svg",
        //       width: "600w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/360.svg",
        //       width: "430w",
        //     },
        //   ],
        //   sizes: `
        //     (max-width: 430px) 430px,
        //     (max-width: 600px) 600px,
        //     (max-width: 720px) 720px,
        //     (max-width: 840px) 840px,
        //     (max-width: 960px) 960px,
        //     (max-width: 1024px) 1024px,
        //     (max-width: 1280px) 1280px,
        //     1440px
        //   `,
        //   alt: "Old Mutual Will",
        //   boldTitle: "",
        //   title: `Join the 30% of South Africans who have a will`,
        //   subtitle: `Create your will online today to ensure your wishes can be honoured and your loved ones are protected.`,
        //   disclaimer: "",
        //   buttonText: "GET STARTED",
        //   buttonLink: "SignUp",
        // },
      ],
    },
    home4: {
      heroBarSourceSets: [
        // {
        //   src: "old_mutual/homepage/hero_bar/home/3/1440.svg",
        //   landscapeSrc: "old_mutual/homepage/hero_bar/home/3/1440.svg",
        //   mobileSrc: "old_mutual/homepage/hero_bar/home/3/360.svg",
        //   iPadMiniSrc: "old_mutual/homepage/hero_bar/home/3/960.svg",
        //   srcset: [
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/1440.svg",
        //       width: "1440w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/1280.svg",
        //       width: "1280w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/1024.svg",
        //       width: "1024w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/960.svg",
        //       width: "960w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/840.svg",
        //       width: "840w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/720.svg",
        //       width: "720w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/600.svg",
        //       width: "600w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/360.svg",
        //       width: "430w",
        //     },
        //   ],
        //   sizes: `
        //     (max-width: 430px) 430px,
        //     (max-width: 600px) 600px,
        //     (max-width: 720px) 720px,
        //     (max-width: 840px) 840px,
        //     (max-width: 960px) 960px,
        //     (max-width: 1024px) 1024px,
        //     (max-width: 1280px) 1280px,
        //     1440px
        //   `,
        //   alt: "Old Mutual Will",
        //   boldTitle: "Create your will online",
        //   title: `with our expert-guided process`,
        //   subtitle: `Create your will online in as litte as 25 minutes`,
        //   disclaimer: "",
        //   buttonText: "START YOUR FREE WILL",
        //   buttonLink: "SignUp",
        // },
        {
          src: 'old_mutual/homepage/hero_bar/home/4/1440.svg',
          landscapeSrc: 'old_mutual/homepage/hero_bar/home/4/1440.svg',
          mobileSrc: 'old_mutual/homepage/hero_bar/home/4/360.svg',
          iPadMiniSrc: 'old_mutual/homepage/hero_bar/home/4/960.svg',
          srcset: [
            {
              url: 'old_mutual/homepage/hero_bar/home/4/1440.svg',
              width: '1440w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/4/1280.svg',
              width: '1280w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/4/1024.svg',
              width: '1024w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/4/960.svg',
              width: '960w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/4/840.svg',
              width: '840w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/4/720.svg',
              width: '720w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/4/600.svg',
              width: '600w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/4/360.svg',
              width: '430w',
            },
          ],
          sizes: `
            (max-width: 430px) 430px,
            (max-width: 600px) 600px,
            (max-width: 720px) 720px,
            (max-width: 840px) 840px,
            (max-width: 960px) 960px,
            (max-width: 1024px) 1024px,
            (max-width: 1280px) 1280px,
            1440px
          `,
          alt: 'Old Mutual Will',
          boldTitle: 'Estate costs and taxes',
          title: `- How much will it be?`,
          subtitle: `Fees and taxes can reduce what your loved ones inherit. Use our calculator to see the impact.`,
          disclaimer: '',
          buttonText: 'CALCULATE MY COSTS',
          buttonLink: 'EstateAdministrationCostCalculator',
        },
        // {
        //   src: "old_mutual/homepage/hero_bar/home/2/1440.svg",
        //   landscapeSrc: "old_mutual/homepage/hero_bar/home/2/1440.svg",
        //   mobileSrc: "old_mutual/homepage/hero_bar/home/2/360.svg",
        //   iPadMiniSrc: "old_mutual/homepage/hero_bar/home/2/960.svg",
        //   srcset: [
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/1440.svg",
        //       width: "1440w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/1280.svg",
        //       width: "1280w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/1024.svg",
        //       width: "1024w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/960.svg",
        //       width: "960w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/840.svg",
        //       width: "840w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/720.svg",
        //       width: "720w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/600.svg",
        //       width: "600w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/360.svg",
        //       width: "430w",
        //     },
        //   ],
        //   sizes: `
        //     (max-width: 430px) 430px,
        //     (max-width: 600px) 600px,
        //     (max-width: 720px) 720px,
        //     (max-width: 840px) 840px,
        //     (max-width: 960px) 960px,
        //     (max-width: 1024px) 1024px,
        //     (max-width: 1280px) 1280px,
        //     1440px
        //   `,
        //   alt: "Old Mutual Will",
        //   boldTitle: "Create your will online",
        //   title: `with our expert-guided process`,
        //   subtitle: `Create your will online in as litte as 25 minutes`,
        //   disclaimer: "",
        //   buttonText: "START YOUR FREE WILL",
        //   buttonLink: "SignUp",
        // },
      ],
    },
    home5: {
      heroBarSourceSets: [
        // {
        //   src: "old_mutual/homepage/hero_bar/home/3/1440.svg",
        //   landscapeSrc: "old_mutual/homepage/hero_bar/home/3/1440.svg",
        //   mobileSrc: "old_mutual/homepage/hero_bar/home/3/360.svg",
        //   iPadMiniSrc: "old_mutual/homepage/hero_bar/home/3/960.svg",
        //   srcset: [
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/1440.svg",
        //       width: "1440w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/1280.svg",
        //       width: "1280w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/1024.svg",
        //       width: "1024w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/960.svg",
        //       width: "960w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/840.svg",
        //       width: "840w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/720.svg",
        //       width: "720w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/600.svg",
        //       width: "600w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/360.svg",
        //       width: "430w",
        //     },
        //   ],
        //   sizes: `
        //     (max-width: 430px) 430px,
        //     (max-width: 600px) 600px,
        //     (max-width: 720px) 720px,
        //     (max-width: 840px) 840px,
        //     (max-width: 960px) 960px,
        //     (max-width: 1024px) 1024px,
        //     (max-width: 1280px) 1280px,
        //     1440px
        //   `,
        //   alt: "Old Mutual Will",
        //   boldTitle: "Create your will online",
        //   title: `with our expert-guided process`,
        //   subtitle: `Create your will online in as litte as 25 minutes`,
        //   disclaimer: "",
        //   buttonText: "START YOUR FREE WILL",
        //   buttonLink: "SignUp",
        // },
        {
          src: 'old_mutual/homepage/hero_bar/home/4/1440.svg',
          landscapeSrc: 'old_mutual/homepage/hero_bar/home/4/1440.svg',
          mobileSrc: 'old_mutual/homepage/hero_bar/home/4/360.svg',
          iPadMiniSrc: 'old_mutual/homepage/hero_bar/home/4/960.svg',
          srcset: [
            {
              url: 'old_mutual/homepage/hero_bar/home/4/1440.svg',
              width: '1440w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/4/1280.svg',
              width: '1280w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/4/1024.svg',
              width: '1024w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/4/960.svg',
              width: '960w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/4/840.svg',
              width: '840w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/4/720.svg',
              width: '720w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/4/600.svg',
              width: '600w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/4/360.svg',
              width: '430w',
            },
          ],
          sizes: `
            (max-width: 430px) 430px,
            (max-width: 600px) 600px,
            (max-width: 720px) 720px,
            (max-width: 840px) 840px,
            (max-width: 960px) 960px,
            (max-width: 1024px) 1024px,
            (max-width: 1280px) 1280px,
            1440px
          `,
          alt: 'Old Mutual Will',
          boldTitle: 'Capital Gains Tax (CGT)',
          title: `- How much do you owe?`,
          subtitle: `Calculate your CGT and learn how to preserve more of your estate for your loved ones.`,
          disclaimer: '',
          buttonText: 'CALCULATE MY CAPITAL GAINS TAX',
          buttonLink: '',
        },
        // {
        //   src: "old_mutual/homepage/hero_bar/home/2/1440.svg",
        //   landscapeSrc: "old_mutual/homepage/hero_bar/home/2/1440.svg",
        //   mobileSrc: "old_mutual/homepage/hero_bar/home/2/360.svg",
        //   iPadMiniSrc: "old_mutual/homepage/hero_bar/home/2/960.svg",
        //   srcset: [
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/1440.svg",
        //       width: "1440w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/1280.svg",
        //       width: "1280w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/1024.svg",
        //       width: "1024w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/960.svg",
        //       width: "960w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/840.svg",
        //       width: "840w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/720.svg",
        //       width: "720w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/600.svg",
        //       width: "600w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/360.svg",
        //       width: "430w",
        //     },
        //   ],
        //   sizes: `
        //     (max-width: 430px) 430px,
        //     (max-width: 600px) 600px,
        //     (max-width: 720px) 720px,
        //     (max-width: 840px) 840px,
        //     (max-width: 960px) 960px,
        //     (max-width: 1024px) 1024px,
        //     (max-width: 1280px) 1280px,
        //     1440px
        //   `,
        //   alt: "Old Mutual Will",
        //   boldTitle: "Create your will online",
        //   title: `with our expert-guided process`,
        //   subtitle: `Create your will online in as litte as 25 minutes`,
        //   disclaimer: "",
        //   buttonText: "START YOUR FREE WILL",
        //   buttonLink: "SignUp",
        // },
      ],
    },
    vodacomCompetition: {
      heroBarSourceSets: [
        // {
        //   src: "old_mutual/homepage/hero_bar/home/3/1440.svg",
        //   landscapeSrc: "old_mutual/homepage/hero_bar/home/3/1440.svg",
        //   mobileSrc: "old_mutual/homepage/hero_bar/home/3/360.svg",
        //   iPadMiniSrc: "old_mutual/homepage/hero_bar/home/3/960.svg",
        //   srcset: [
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/1440.svg",
        //       width: "1440w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/1280.svg",
        //       width: "1280w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/1024.svg",
        //       width: "1024w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/960.svg",
        //       width: "960w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/840.svg",
        //       width: "840w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/720.svg",
        //       width: "720w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/600.svg",
        //       width: "600w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/3/360.svg",
        //       width: "430w",
        //     },
        //   ],
        //   sizes: `
        //     (max-width: 430px) 430px,
        //     (max-width: 600px) 600px,
        //     (max-width: 720px) 720px,
        //     (max-width: 840px) 840px,
        //     (max-width: 960px) 960px,
        //     (max-width: 1024px) 1024px,
        //     (max-width: 1280px) 1280px,
        //     1440px
        //   `,
        //   alt: "Old Mutual Will",
        //   boldTitle: "Create your will online",
        //   title: `with our expert-guided process`,
        //   subtitle: `Create your will online in as litte as 25 minutes`,
        //   disclaimer: "",
        //   buttonText: "START YOUR FREE WILL",
        //   buttonLink: "SignUp",
        // },
        {
          src: 'old_mutual/homepage/hero_bar/home/1/1440.svg',
          landscapeSrc: 'old_mutual/homepage/hero_bar/home/1/1440.svg',
          mobileSrc: 'old_mutual/homepage/hero_bar/home/1/360.svg',
          iPadMiniSrc: 'old_mutual/homepage/hero_bar/home/1/960.svg',
          srcset: [
            {
              url: 'old_mutual/homepage/hero_bar/home/1/1440.svg',
              width: '1440w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/1280.svg',
              width: '1280w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/1024.svg',
              width: '1024w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/960.svg',
              width: '960w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/840.svg',
              width: '840w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/720.svg',
              width: '720w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/600.svg',
              width: '600w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/home/1/360.svg',
              width: '430w',
            },
          ],
          sizes: `
            (max-width: 430px) 430px,
            (max-width: 600px) 600px,
            (max-width: 720px) 720px,
            (max-width: 840px) 840px,
            (max-width: 960px) 960px,
            (max-width: 1024px) 1024px,
            (max-width: 1280px) 1280px,
            1440px
          `,
          alt: 'Old Mutual Will',
          boldTitle: 'Protect Your Legacy, Family, and Wishes',
          title: ``,
          subtitle: `Create your will online in as little as 25 minutes`,
          disclaimer: '',
          buttonText: 'CREATE YOUR WILL',
          buttonLink: 'SignUp',
        },
        // {
        //   src: "old_mutual/homepage/hero_bar/home/2/1440.svg",
        //   landscapeSrc: "old_mutual/homepage/hero_bar/home/2/1440.svg",
        //   mobileSrc: "old_mutual/homepage/hero_bar/home/2/360.svg",
        //   iPadMiniSrc: "old_mutual/homepage/hero_bar/home/2/960.svg",
        //   srcset: [
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/1440.svg",
        //       width: "1440w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/1280.svg",
        //       width: "1280w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/1024.svg",
        //       width: "1024w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/960.svg",
        //       width: "960w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/840.svg",
        //       width: "840w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/720.svg",
        //       width: "720w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/600.svg",
        //       width: "600w",
        //     },
        //     {
        //       url: "old_mutual/homepage/hero_bar/home/2/360.svg",
        //       width: "430w",
        //     },
        //   ],
        //   sizes: `
        //     (max-width: 430px) 430px,
        //     (max-width: 600px) 600px,
        //     (max-width: 720px) 720px,
        //     (max-width: 840px) 840px,
        //     (max-width: 960px) 960px,
        //     (max-width: 1024px) 1024px,
        //     (max-width: 1280px) 1280px,
        //     1440px
        //   `,
        //   alt: "Old Mutual Will",
        //   boldTitle: "Create your will online",
        //   title: `with our expert-guided process`,
        //   subtitle: `Create your will online in as litte as 25 minutes`,
        //   disclaimer: "",
        //   buttonText: "START YOUR FREE WILL",
        //   buttonLink: "SignUp",
        // },
      ],
    },
    articles: {
      heroBarSourceSets: [
        {
          src: 'old_mutual/homepage/hero_bar/articles/1440.svg',
          landscapeSrc: 'old_mutual/homepage/hero_bar/articles/1440.svg',
          mobileSrc: 'old_mutual/homepage/hero_bar/articles/360.svg',
          iPadMiniSrc: 'old_mutual/homepage/hero_bar/articles/960.svg',
          srcset: [
            {
              url: 'old_mutual/homepage/hero_bar/articles/1440.svg',
              width: '1440w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/articles/1280.svg',
              width: '1280w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/articles/1024.svg',
              width: '1024w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/articles/960.svg',
              width: '960w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/articles/840.svg',
              width: '840w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/articles/720.svg',
              width: '720w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/articles/600.svg',
              width: '600w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/articles/360.svg',
              width: '430w',
            },
          ],
          sizes: `
            (max-width: 430px) 430px,
            (max-width: 600px) 600px,
            (max-width: 720px) 720px,
            (max-width: 840px) 840px,
            (max-width: 960px) 960px,
            (max-width: 1024px) 1024px,
            (max-width: 1280px) 1280px,
            1440px
          `,
          alt: 'Old Mutual Will',
          boldTitle: 'Creating a will',
          title: `shouldn't be overwhelming`,
          subtitle: `Our straightforward process makes creating your will easier, securing the future of your loved ones.`,
          disclaimer: '',
          buttonText: 'How It Works',
          buttonLink: 'HowItWorks',
        },
      ],
    },
    calculator: {
      heroBarSourceSets: [
        {
          src: 'old_mutual/homepage/hero_bar/calculator/1440.svg',
          landscapeSrc: 'old_mutual/homepage/hero_bar/calculator/1440.svg',
          mobileSrc: 'old_mutual/homepage/hero_bar/calculator/360.svg',
          iPadMiniSrc: 'old_mutual/homepage/hero_bar/calculator/960.svg',
          srcset: [
            {
              url: 'old_mutual/homepage/hero_bar/calculator/1440.svg',
              width: '1440w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/calculator/1280.svg',
              width: '1280w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/calculator/1024.svg',
              width: '1024w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/calculator/960.svg',
              width: '960w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/calculator/840.svg',
              width: '840w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/calculator/720.svg',
              width: '720w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/calculator/600.svg',
              width: '600w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/calculator/360.svg',
              width: '430w',
            },
          ],
          sizes: `
            (max-width: 430px) 430px,
            (max-width: 600px) 600px,
            (max-width: 720px) 720px,
            (max-width: 840px) 840px,
            (max-width: 960px) 960px,
            (max-width: 1024px) 1024px,
            (max-width: 1280px) 1280px,
            1440px
          `,
          alt: 'Old Mutual Will',
          boldTitle: 'Creating a will',
          title: `shouldn't be overwhelming`,
          subtitle: `Our straightforward process makes creating your will easier, securing the future of your loved ones.`,
          disclaimer: '',
          buttonText: 'How It Works',
          buttonLink: 'HowItWorks',
        },
      ],
    },
    faqs: {
      heroBarSourceSets: [
        {
          src: 'old_mutual/homepage/hero_bar/faqs/1440.svg',
          landscapeSrc: 'old_mutual/homepage/hero_bar/faqs/1440.svg',
          mobileSrc: 'old_mutual/homepage/hero_bar/faqs/360.svg',
          iPadMiniSrc: 'old_mutual/homepage/hero_bar/faqs/960.svg',
          srcset: [
            {
              url: 'old_mutual/homepage/hero_bar/faqs/1440.svg',
              width: '1440w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/faqs/1280.svg',
              width: '1280w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/faqs/1024.svg',
              width: '1024w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/faqs/960.svg',
              width: '960w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/faqs/840.svg',
              width: '840w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/faqs/720.svg',
              width: '720w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/faqs/600.svg',
              width: '600w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/faqs/360.svg',
              width: '430w',
            },
          ],
          sizes: `
            (max-width: 430px) 430px,
            (max-width: 600px) 600px,
            (max-width: 720px) 720px,
            (max-width: 840px) 840px,
            (max-width: 960px) 960px,
            (max-width: 1024px) 1024px,
            (max-width: 1280px) 1280px,
            1440px
          `,
          alt: 'Old Mutual Will',
          boldTitle: 'Creating a will',
          title: `shouldn't be overwhelming`,
          subtitle: `Our straightforward process makes creating your will easier, securing the future of your loved ones.`,
          disclaimer: '',
          buttonText: 'How It Works',
          buttonLink: 'HowItWorks',
        },
      ],
    },
    howItWorks: {
      heroBarSourceSets: [
        {
          src: 'old_mutual/homepage/hero_bar/how-it-works/1440.svg',
          landscapeSrc: 'old_mutual/homepage/hero_bar/how-it-works/1440.svg',
          mobileSrc: 'old_mutual/homepage/hero_bar/how-it-works/360.svg',
          iPadMiniSrc: 'old_mutual/homepage/hero_bar/how-it-works/960.svg',
          srcset: [
            {
              url: 'old_mutual/homepage/hero_bar/how-it-works/1440.svg',
              width: '1440w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/how-it-works/1280.svg',
              width: '1280w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/how-it-works/1024.svg',
              width: '1024w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/how-it-works/960.svg',
              width: '960w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/how-it-works/840.svg',
              width: '840w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/how-it-works/720.svg',
              width: '720w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/how-it-works/600.svg',
              width: '600w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/how-it-works/360.svg',
              width: '430w',
            },
          ],
          sizes: `
            (max-width: 430px) 430px,
            (max-width: 600px) 600px,
            (max-width: 720px) 720px,
            (max-width: 840px) 840px,
            (max-width: 960px) 960px,
            (max-width: 1024px) 1024px,
            (max-width: 1280px) 1280px,
            1440px
          `,
          alt: 'Old Mutual Will',
          boldTitle: 'Creating a will',
          title: `shouldn't be overwhelming`,
          subtitle: `Our straightforward process makes creating your will easier, securing the future of your loved ones.`,
          disclaimer: '',
          buttonText: 'How It Works',
          buttonLink: 'HowItWorks',
        },
      ],
    },
    ourSolutions: {
      heroBarSourceSets: [
        {
          src: 'old_mutual/homepage/hero_bar/our-solutions/1440.svg',
          landscapeSrc: 'old_mutual/homepage/hero_bar/our-solutions/1440.svg',
          mobileSrc: 'old_mutual/homepage/hero_bar/our-solutions/360.svg',
          iPadMiniSrc: 'old_mutual/homepage/hero_bar/our-solutions/960.svg',
          srcset: [
            {
              url: 'old_mutual/homepage/hero_bar/our-solutions/1440.svg',
              width: '1440w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/our-solutions/1280.svg',
              width: '1280w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/our-solutions/1024.svg',
              width: '1024w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/our-solutions/960.svg',
              width: '960w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/our-solutions/840.svg',
              width: '840w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/our-solutions/720.svg',
              width: '720w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/our-solutions/600.svg',
              width: '600w',
            },
            {
              url: 'old_mutual/homepage/hero_bar/our-solutions/360.svg',
              width: '430w',
            },
          ],
          sizes: `
            (max-width: 430px) 430px,
            (max-width: 600px) 600px,
            (max-width: 720px) 720px,
            (max-width: 840px) 840px,
            (max-width: 960px) 960px,
            (max-width: 1024px) 1024px,
            (max-width: 1280px) 1280px,
            1440px
          `,
          alt: 'Old Mutual Will',
          boldTitle: 'Creating a will',
          title: `shouldn't be overwhelming`,
          subtitle: `Our straightforward process makes creating your will easier, securing the future of your loved ones.`,
          disclaimer: '',
          buttonText: 'How It Works',
          buttonLink: 'HowItWorks',
        },
      ],
    },
    advisersHeader: {
      heroBarSourceSets: [
        {
          ...ADVISER_HERO_IMAGES,
          boldTitle: 'Know more.',
          title: 'Earn more*.',
          subtitle: 'One Will conversation, more ways to earn.',
          disclaimer:
            '* The channel agreement sets the fee for the specific channel',
        },
      ],
    },
    adviserIfaHeader: {
      heroBarSourceSets: [
        {
          ...ADVISER_HERO_IMAGES,
          boldTitle: '',
          title: 'Start with a will. Unlock a world of advice opportunities.',
          subtitle:
            'Get registered to use Old Mutual Will as a powerful conversation starter with your clients.',
          disclaimer: '',
        },
      ],
    },
    adviserPfHeader: {
      heroBarSourceSets: [
        {
          ...ADVISER_HERO_IMAGES,
          boldTitle: '',
          title: 'Earn R500 per signed and validated will*.',
          subtitle: 'Simply get registered to unlock your earning potential.',
          disclaimer:
            '*Ts&Cs apply. The channel agreement sets the fee for the specific channel.',
        },
      ],
    },
    adviserFaqsHeader: {
      heroBarSourceSets: [
        {
          ...ADVISER_HERO_IMAGES,
          boldTitle: '',
          title: 'Adviser FAQs',
          subtitle:
            'Answers to the most common questions about using the Old Mutual Will platform.',
          disclaimer: '',
        },
      ],
    },
    adviserResourcesHeader: {
      heroBarSourceSets: [
        {
          ...ADVISER_HERO_IMAGES,
          boldTitle: '',
          title: 'Adviser Resources',
          subtitle: 'Resources to help you get started with Old Mutual Will',
          disclaimer: '',
        },
      ],
    },
    advisersFooter: {
      heroBarSourceSets: [
        {
          src: 'old_mutual/adviser-enrolment/adviser-enrolment-footer.png',
          landscapeSrc:
            'old_mutual/adviser-enrolment/adviser-enrolment-footer.png',
          mobileSrc:
            'old_mutual/adviser-enrolment/adviser-enrolment-footer.png',
          iPadMiniSrc:
            'old_mutual/adviser-enrolment/adviser-enrolment-footer.png',
          srcset: [
            {
              url: 'old_mutual/adviser-enrolment/adviser-enrolment-footer.png',
              width: '1440w',
            },
          ],
          sizes: `
            (max-width: 430px) 430px,
            (max-width: 600px) 600px,
            (max-width: 720px) 720px,
            (max-width: 840px) 840px,
            (max-width: 960px) 960px,
            (max-width: 1024px) 1024px,
            (max-width: 1280px) 1280px,
            1440px
          `,
          alt: '',
          boldTitle: '',
          title: ``,
          subtitle: ``,
          disclaimer: '',
          buttonText: '',
          buttonLink: '',
        },
      ],
    },
    logo: null,
    homeMain: 'old_mutual/homepage/main_header1.svg',
    mobileHomeMain: 'old_mutual/homepage/mobile_header.svg',
    homeSteps1: 'old_mutual/homepage/steps1.svg',
    homeSteps2: 'old_mutual/homepage/steps2.svg',
    homeSteps3: 'old_mutual/homepage/steps3.svg',
    homeSteps4: 'old_mutual/homepage/steps4.svg',
    homeUsp1: 'old_mutual/homepage/usp_icon1.svg',
    homeUsp2: 'old_mutual/homepage/usp_icon2.svg',
    homeUsp3: 'old_mutual/homepage/usp_icon3.svg',
    homeUsp4: 'old_mutual/homepage/usp_icon4.svg',
    homeTestatimonial1: null,
    homeTestatimonial2: null,
    homeTestatimonial3: null,
    overviewStep1: 'old_mutual/overview/about_yourself.svg',
    overviewStep2: 'old_mutual/overview/people.svg',
    overviewStep3: 'old_mutual/overview/assets.svg',
    overviewStep4: 'old_mutual/overview/sparkly_btc.svg',
    overviewStep5: 'old_mutual/overview/remainder1.svg',
    overviewStep6: 'old_mutual/overview/letter_of_wishes.svg',
    overviewStep7: 'old_mutual/overview/insurance.svg',
    aboutYourselfPage: 'old_mutual/overview/about_yourself.svg',
    assetsPage: 'old_mutual/overview/remainder1.svg',
    worldWideAssetsPage: 'old_mutual/overview/remainder1.svg',
    pageNotFound: 'old_mutual/overview/pet_bostie.svg',
    insuranceAgeRestrictedPage: 'old_mutual/overview/charity_pig.svg',
    estimatedInsuranceRequiredPage: 'old_mutual/insurance/insurance.svg',
    estimatedInsuranceRequiredInputPage:
      'old_mutual/insurance/estimated-insurance-required-input.svg',
    estimatedInsuranceRequiredOutputPage:
      'old_mutual/insurance/estimated-insurance-required-output.svg',
    getFreeInsuranceQuotePageTop:
      'quickwill/insurance/get-free-insurance-quote-page-top.svg',
    getFreeInsuranceQuotePageBottom:
      'quickwill/insurance/get-free-insurance-quote-page-bottom.svg',
    getFreeInsuranceQuotePageSmoker: 'quickwill/insurance/smoker.svg',
    getFreeInsuranceQuotePageNonSmoker: 'quickwill/insurance/non-smoker.svg',
    getFreeInsuranceQuotePageSmokerSelected:
      'quickwill/insurance/smoker-selected.svg',
    getFreeInsuranceQuotePageNonSmokerSelected:
      'quickwill/insurance/non-smoker-selected.svg',
    insuranceBankingDetailsPage: 'old_mutual/insurance/banking-details.svg',
    insuranceExplanationPage: 'old_mutual/insurance/explanation.svg',
    insuranceQuestionsPage: 'old_mutual/insurance/questions.svg',
    insuranceNonSACitizenPage: 'old_mutual/overview/charity_pig.svg',
    insuranceRequestAdvisorCallPage: 'old_mutual/insurance/explanation.svg',
    letterOfWishesPage: 'old_mutual/overview/letter_of_wishes.svg',
    livingWillPage: 'old_mutual/overview/living-will.svg',
    manageAccountPage: 'old_mutual/overview/about_yourself.svg',
    peopleOverviewPage: 'old_mutual/overview/people.svg',
    peopleOverviewSpouse: 'old_mutual/overview/spouse.svg',
    peopleOverviewChildren: 'old_mutual/overview/guardian.svg',
    peopleOverviewExecutor: 'old_mutual/overview/executor.svg',
    peopleOverviewHeir: 'old_mutual/overview/heir.svg',
    peopleOverviewCharities: 'old_mutual/overview/charity_box.svg',
    peopleOverviewTrusts: 'old_mutual/overview/charity_pig.svg',
    distributionSpecificPercentageAlternativesPage:
      'old_mutual/overview/remainder1.svg',
    assetDonationPage: 'old_mutual/overview/assets.svg',
    moneyDonationPage: 'old_mutual/overview/money_1.svg',
    specificDonationsPageAssets: 'old_mutual/overview/assets.svg',
    specificDonationsPageMoney: 'old_mutual/overview/money_1.svg',
    activateAccountPageMain:
      'old_mutual/activation-landing-page/house_and_funeral.svg',
    activateAccountPage1: 'old_mutual/activation-landing-page/will.svg',
    activateAccountPage2: 'old_mutual/activation-landing-page/rand_money.svg',
    activateAccountPage3: 'old_mutual/activation-landing-page/tombstone.svg',
    activateAccountPage4: 'old_mutual/activation-landing-page/sold_house.svg',
    activateAccountPage5:
      'old_mutual/activation-landing-page/will_being_read.svg',
    activateAccountPage6: 'old_mutual/activation-landing-page/executor.svg',
    executorExplainerMain: 'old_mutual/advisor-page/quinton.svg',
    executorExplainerHowDoesItWork1: 'old_mutual/executor/post_box.svg',
    executorExplainerHowDoesItWork2: 'old_mutual/executor/coffin.svg',
    executorExplainerHowDoesItWork3: 'old_mutual/executor/nomination_form.svg',
    executorExplainerHowDoesItWork4: 'old_mutual/executor/post_box_letter.svg',
    executorExplainerEstateAdminPartner: 'old_mutual/executor/ashmanslogo.png',
    advisorPageMain: 'old_mutual/advisor-page/quinton.svg',
    advisorPageWhyUseUs1: 'old_mutual/advisor-page/marketing_sharing.svg',
    advisorPageWhyUseUs2: 'old_mutual/advisor-page/bostie_and_leash.svg',
    advisorPageWhyUseUs3: 'old_mutual/advisor-page/scale.svg',
    advisorPageWhyUseUs4: 'old_mutual/advisor-page/executor.svg',
    advisorPageWhyUseUs5: 'old_mutual/advisor-page/dashboard.svg',
  },
  cssLogo: true,
  fontFamily:
    'Montserrat, Gill Sans, Gill Sans MT, Calibri, Trebuchet MS, sans-serif',
  homeUrl: 'www.oldmutualwill.com',
  pageTitle: 'Create Your Will Online | Quick And Easy',
  getStartedBtnColor: 'primary',
  showTrustpilot: false,
  facebookPageUrl: null,
  linkedInPageUrl: null,
  contactTelNumber: '021 753 3248',
  contactEmail: 'support@oldmutualwill.co.za',
  showHomePageTestimonials: true,
  testimonialText1:
    'As soon as I completed my will, I received an email, and it was ready to be signed. I found the experience quick and easy!',
  testimonialName1: 'Tumi Marota',
  testimonialText2:
    'My online experience was perfect, I completed my will in my own privacy and time. My will was reviewed in 72 hours.',
  testimonialName2: 'Abulele Gumede',
  testimonialText3:
    'The process of completing my will was so easy! The online service provided a step-by-step guide which took less than 15 minutes to complete, and the legal vetting process took less than a day.',
  testimonialName3: 'Mark Davids',
  showHomePageAbout: false,
  FAQUrl: '/faqs',
  blogUrl: '/articles',
  showFinancialAdvisorExplainerPage: false,
  showExecutorExplainerPage: false,
  insuranceCallUsTel: '021 753 3248',
  loginPageMessage: '',
  homePagePopupMessage: null,
  showQWExecutorLinks: false,
  internalExecutorName: 'Old Mutual Will',
  showAdvisorAccessRequest: true,
  estateAdministrationCostCalculator: {
    conveyancingFeesData: {
      tiers: [
        {
          tier: 1,
          minValue: 0,
          maxValue: 100000,
          baseFee: 6435,
          incrementalFee: 0,
          increment: null,
          incrementPoint: null,
        },
        {
          tier: 2,
          minValue: 100001,
          maxValue: 500000,
          baseFee: 6435,
          incrementalFee: 1025,
          increment: 50000,
          incrementPoint: 100000,
        },
        {
          tier: 3,
          minValue: 500001,
          maxValue: 1000000,
          baseFee: 14635,
          incrementalFee: 1985,
          increment: 100000,
          incrementPoint: 500000,
        },
        {
          tier: 4,
          minValue: 1000001,
          maxValue: 5000000,
          baseFee: 24560,
          incrementalFee: 1985,
          increment: 200000,
          incrementPoint: 1000000,
        },
        {
          tier: 5,
          minValue: 5000001,
          maxValue: Infinity,
          baseFee: 64260,
          incrementalFee: 5000,
          increment: 1000000,
          incrementPoint: 5000000,
        },
      ],
    },
  },
  termsAndConditionsLocation: '/terms-and-conditions',
  canonicalUrls: {
    homepage: 'https://www.oldmutualwill.co.za',
    signup: 'https://www.oldmutualwill.co.za/signup',
    login: 'https://www.oldmutualwill.co.za/login',
    termsAndConditions: 'https://www.oldmutualwill.co.za/terms-and-conditions',
    competitionTermsAndConditions:
      'https://www.oldmutualwill.co.za/competition-terms-and-conditions',
    forgotPassword: 'https://www.oldmutualwill.co.za/forgot-password',
  },
  meta: {
    data: [
      {
        property: 'description',
        content:
          "Create your will online with Old Mutual's easy, secure, and free platform. Draft and download your will in four simple steps without needing a lawyer.",
      },
      {
        property: 'og:title',
        content: 'Old Mutual Will: Create Your Will Online, Quick and Easy',
      },
      {
        property: 'og:image',
        content: 'https://www.oldmutualwill.co.za/meta/old-mutual-will.png',
      },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: '/' },
      {
        property: 'og:description',
        content:
          'Protect your family by creating your legally binding will, online, in just minutes.',
      },
      { property: 'og:site_name', content: 'Old Mutual Will' },
    ],
    links: {
      favicon: 'favicons/om-favicon.png',
      font: 'https://fonts.googleapis.com/css?family=Montserrat:100,300,400,500,600,700,900',
    },
    scripts: [
      {
        type: 'application/ld+json',
        json: {
          '@context': 'http://schema.org',
          '@type': 'Organization',
          name: 'Old Mutual Will',
          url: 'https://www.oldmutualwill.co.za',
          address: 'Mutualpark, Jan Smuts Drive, Cape Town',
          sameAs: ['https://www.facebook.com/61558538057385/'],
        },
      },
    ],
  },
  metaData: {
    howItWorks: {
      title: 'Create Your Will Online | How It Works',
      description:
        'Planning for the future can be overwhelming, but we make it straightforward, secure, and stress-free.',
      ogTitle: 'Old Mutual Will: Create Your Will Online, Quick and Easy',
      ogImage: 'https://www.oldmutualwill.co.za/meta/old-mutual-will.png',
      ogType: 'website',
      ogUrl: 'https://www.oldmutualwill.co.za/how-it-works',
      ogDescription:
        'Protect your family by creating your legally binding will, online, in just minutes.',
      ogSiteName: 'Old Mutual Will',
    },
    ourSolutions: {
      title: 'Create Your Will Online | Our Solutions',
      description:
        'Planning for the future can be overwhelming, but we make it straightforward, secure, and stress-free.',
      ogTitle: 'Old Mutual Will: Create Your Will Online, Quick and Easy',
      ogImage: 'https://www.oldmutualwill.co.za/meta/old-mutual-will.png',
      ogType: 'website',
      ogUrl: 'https://www.oldmutualwill.co.za/our-solutions',
      ogDescription:
        'Protect your family by creating your legally binding will, online, in just minutes.',
      ogSiteName: 'Old Mutual Will',
    },
    calculator: {
      title: 'Create Your Will Online | Estate Administration Cost Calculator',
      description:
        'Planning for the future can be overwhelming, but we make it straightforward, secure, and stress-free.',
      ogTitle: 'Old Mutual Will: Create Your Will Online, Quick and Easy',
      ogImage: 'https://www.oldmutualwill.co.za/meta/old-mutual-will.png',
      ogType: 'website',
      ogUrl:
        'https://www.oldmutualwill.co.za/estate-administration-cost-calculator',
      ogDescription:
        'Protect your family by creating your legally binding will, online, in just minutes.',
      ogSiteName: 'Old Mutual Will',
    },
    faqs: {
      title: 'Create Your Will Online | FAQs',
      description:
        'Planning for the future can be overwhelming, but we make it straightforward, secure, and stress-free.',
      ogTitle: 'Old Mutual Will: Create Your Will Online, Quick and Easy',
      ogImage: 'https://www.oldmutualwill.co.za/meta/old-mutual-will.png',
      ogType: 'website',
      ogUrl: 'https://www.oldmutualwill.co.za/faqs',
      ogDescription:
        'Protect your family by creating your legally binding will, online, in just minutes.',
      ogSiteName: 'Old Mutual Will',
    },
    articles: {
      title: 'Create Your Will Online | Articles',
      description:
        'Planning for the future can be overwhelming, but we make it straightforward, secure, and stress-free.',
      ogTitle: 'Old Mutual Will: Create Your Will Online, Quick and Easy',
      ogImage: 'https://www.oldmutualwill.co.za/meta/old-mutual-will.png',
      ogType: 'website',
      ogUrl: 'https://www.oldmutualwill.co.za/articles',
      ogDescription:
        'Protect your family by creating your legally binding will, online, in just minutes.',
      ogSiteName: 'Old Mutual Will',
    },
  },
  // Adviser FAQs for /adviser/faqs (OMW-419). Same {title, content} shape as
  // FAQs above, grouped by category. Source: OMW Adviser FAQ_V1.0.docx.
  adviserFAQs: [
    {
      title: 'Validity, eligibility & security',
      faqs: [
        {
          title: 'Is creating a will online with Old Mutual valid?',
          content: `<p>Yes. A will created through Old Mutual is valid and binding as long as it meets the necessary legal requirements, such as proper signing and witnessing. Clients receive clear instructions to ensure compliance.</p>`,
        },
        {
          title: 'Who is eligible to use Old Mutual’s online will service?',
          content: `<p>The service is available to South African residents aged 16 years or older.</p>`,
        },
        {
          title:
            'How does Old Mutual ensure the security of my clients’ personal information?',
          content: `<p>Old Mutual uses industry-leading encryption and security protocols to protect sensitive data. All personal and financial details remain confidential and are never shared without consent.</p>`,
        },
      ],
    },
    {
      title: 'Making changes & storage',
      faqs: [
        {
          title:
            'Can my client make changes to their will after they’ve created it?',
          content: `<p>Yes. Clients can edit their will at any time before finalising and signing it. It’s advisable to update a will after major life events such as marriage, divorce, having children, or acquiring significant assets. There are no limitations on updates to the will, and updates are free. To update the will, the client can simply log into the platform, change the relevant details and download the revised version. It is important to note that the new version needs to be signed for it to supersede the previous version.</p>`,
        },
        {
          title: 'Does Old Mutual charge a storage fee?',
          content: `<p>No. Storage and one collection of the signed will are free of charge, once per year. This ensures the original will is securely stored and accessible when needed.</p>`,
        },
      ],
    },
    {
      title: 'Process & costs',
      faqs: [
        {
          title:
            'What does it cost for my client to create a will with Old Mutual?',
          content: `<p>The will drafting service is completely free — drafting, collection and secure storage are all included.</p>`,
        },
        {
          title: 'How does the process work?',
          content: `<ol>
            <li>The adviser links the customer to his or her adviser profile, through either the “add testator” or “referral link” functionalities on their adviser dashboard.</li>
            <li>The client uses the link to create an account, or password for their account, on the Old Mutual Will platform which is then linked to the adviser profile.</li>
            <li>The adviser guides the client through the online will creation process.</li>
            <li>The client reviews, prints, signs, and has their will witnessed as per legal requirements.</li>
            <li>The signed will is uploaded onto the system for validation.</li>
            <li>The signed and validated will is collected (free once per year) and securely stored by Old Mutual.</li>
          </ol>`,
        },
        {
          title: 'What happens if a client does not sign or return their will?',
          content: `<p>If a will is not signed, it will not be valid. Advisers should encourage clients to follow through with signing and submission to complete the process. Storing the will with Old Mutual is to the benefit of the customer but is not a requirement — it is a benefit, free of charge, to the customer.</p>`,
        },
      ],
    },
    {
      title: 'Old Mutual Will vs Old Mutual Trust',
      faqs: [
        {
          title: 'How is Old Mutual Will different from Old Mutual Trust?',
          content: `<p>Old Mutual Will is the digital, supported route for valid will creation at scale. Old Mutual Trust remains the specialist fiduciary service for more complex estates. The two work alongside each other.</p>
            <div class="comparison-table">
              <div class="comparison-heading">What it is (in one line)</div>
              <table><thead><tr><th>Old Mutual Trust</th><th>Old Mutual Will</th></tr></thead>
              <tbody><tr><td>A full fiduciary / estate planning service with wills, trusts and estate administration support.</td><td>A human-supported digital solution that enables advisers to help clients create a valid will online, understand estate costs, secure estate protection, and ensure professional estate administration.</td></tr></tbody></table>
            </div>
            <div class="comparison-table">
              <div class="comparison-heading">Best for</div>
              <table><thead><tr><th>Old Mutual Trust</th><th>Old Mutual Will</th></tr></thead>
              <tbody><tr><td>Clients with complex estates requiring specialist estate structuring, trusts, and tax planning.</td><td>Clients who want a time-efficient, accessible and guided way to get a will done, plus the comfort that their estate will be administered for them via our partnered executors.</td></tr></tbody></table>
            </div>
            <div class="comparison-table">
              <div class="comparison-heading">How the client gets started</div>
              <table><thead><tr><th>Old Mutual Trust</th><th>Old Mutual Will</th></tr></thead>
              <tbody><tr><td>Adviser-led, for complex planning conversations.</td><td>Can be client-initiated directly via the online platform, or adviser-led and facilitated through the digital platform.</td></tr></tbody></table>
            </div>
            <div class="comparison-table">
              <div class="comparison-heading">How the will is created</div>
              <table><thead><tr><th>Old Mutual Trust</th><th>Old Mutual Will</th></tr></thead>
              <tbody><tr><td>Paper-based initial capturing, then shared with legal professionals for drafting.</td><td>Guided online step-by-step process that helps the client or adviser build a valid will (digital journey). The will is available instantly for download after initial capturing.</td></tr></tbody></table>
            </div>
            <div class="comparison-table">
              <div class="comparison-heading">Level of human support</div>
              <table><thead><tr><th>Old Mutual Trust</th><th>Old Mutual Will</th></tr></thead>
              <tbody><tr><td>High-touch, including specialist support for complex estates and typically more direct expert involvement (e.g. attorney-led engagement depending on need).</td><td>Human-supported digital solution. The customer can complete it fully online, be supported by the OM Will Call Centre agents, or where applicable by his/her adviser.</td></tr></tbody></table>
            </div>
            <div class="comparison-table">
              <div class="comparison-heading">Safe storage (custody)</div>
              <table><thead><tr><th>Old Mutual Trust</th><th>Old Mutual Will</th></tr></thead>
              <tbody><tr><td>Provides safe custody of the will and related documents at a monthly cost.</td><td>Safe storage included. The customer signs and uploads, and the physical copy can be collected for safekeeping at no cost to the customer.</td></tr></tbody></table>
            </div>
            <div class="comparison-table">
              <div class="comparison-heading">Estate administration (when the client dies)</div>
              <table><thead><tr><th>Old Mutual Trust</th><th>Old Mutual Will</th></tr></thead>
              <tbody><tr><td>Estate administration is a core part of the proposition (with internal capability and an outsourced network).</td><td>Estate administration is included via an estate administration partner who can handle the process end-to-end.</td></tr></tbody></table>
            </div>
            <div class="comparison-table">
              <div class="comparison-heading">Executor offering / fees</div>
              <table><thead><tr><th>Old Mutual Trust</th><th>Old Mutual Will</th></tr></thead>
              <tbody><tr><td>Strong focus on executor value, including discounted executor fees (per their proposition).</td><td>Focus is on making will creation accessible while ensuring a clear path to administration where Old Mutual Will is appointed as executor. Standard fees apply. Discounted executor fees are negotiable for estates above R5 million at the time of estate administration.</td></tr></tbody></table>
            </div>
            <div class="comparison-table">
              <div class="comparison-heading">Trusts & extra services</div>
              <table><thead><tr><th>Old Mutual Trust</th><th>Old Mutual Will</th></tr></thead>
              <tbody><tr><td>Broad: can include living trusts, testamentary trusts, and accounting/tax-related support (where offered).</td><td>Focused: primarily will creation and safe storage, with options like a testamentary trust or umbrella trusts in future where relevant, and estate administration via partner.</td></tr></tbody></table>
            </div>
            <div class="comparison-table">
              <div class="comparison-heading">Ongoing maintenance</div>
              <table><thead><tr><th>Old Mutual Trust</th><th>Old Mutual Will</th></tr></thead>
              <tbody><tr><td>Ongoing support is available, but the update approach depends on the service path used.</td><td>Built for “life happens”: easier to review and update as circumstances change. No limitations on updates to the will, and updates are free.</td></tr></tbody></table>
            </div>`,
        },
      ],
    },
    {
      title:
        'The adviser relationship, estate liquidity and estate administration',
      faqs: [
        {
          title: 'Will you contact my clients directly?',
          content: `<p>No. The client relationship remains with you. Old Mutual Will only engages a client directly if they initiate a support request themselves.</p>`,
        },
        {
          title:
            'Where do I start the estate liquidity conversation with my client?',
          content: `<p>As part of the wills process, you will already have a view of the client’s dependents and wishes for asset distribution. The final step will be to capture pertinent information related to the assets and liabilities which is then used in conjunction with the rest of the will information to generate an estimated estate administration cost summary. This summary will consider key costs such as estate administration fees, master’s fees, estate duty and taxes as well as standard administrative costs.</p>
            <p>Understanding this value provides the ideal opportunity for you to have a financial planning discussion around estate liquidity.</p>`,
        },
        {
          title: 'How does the OMP product sale work',
          content: `<p>You will receive a structured summary from the Will journey, with the details you need to capture the sale in the Old Mutual new business dashboard. These details are captured in a Personal Financial Questionnaire (PFQ). The PFQ contains the key information you need to capture the sale in the new business dashboard.</p>
            <p>When logging in to this dashboard, you will initiate a Protection Solution Recommendation or Standalone Quote. You then select Life, Last Survivor or Accidental Death Cover, and select the reason for cover as ‘Liquidity in the Estate’ on the ‘Owners’ page. Please note that for the Liquidity in Estate reason for cover to become available for selection, the insured person and owner must be the same.</p>
            <p>The PFQ generated from the Will journey does not provide a one-click integration, but the client data is already in the format you need.</p>`,
        },
        {
          title: 'How do I report a death?',
          content: `<p>Deaths can be reported by emailing <a href="mailto:support@oldmutualwill.co.za">support@oldmutualwill.co.za</a>. The estate administration team will guide you and your client through every step of the process.</p>`,
        },
        {
          title: 'What does the estate administration process entail?',
          content: `<p>Old Mutual Will facilitates the estate administration process in partnership with its panel of estate administrators to deliver a professional and supported process.</p>
            <p>The typical time frames related to simple estate administration process are as follows:</p>
            <ol>
              <li>Reporting to the Master’s Office – 2 – 4 Weeks</li>
              <li>Executor Appointment – 8 – 12 weeks</li>
              <li>Creditors / Debtors notice – 4 weeks</li>
              <li>Valuation and Tax handling – 5 – 6 weeks</li>
              <li>Liquidation and distribution – up to 6 months</li>
              <li>Public notice (Inspection) – 21 days</li>
              <li>Asset distribution – 8 – 10 weeks</li>
              <li>Finalisation &amp; closure – 10 – 12 weeks</li>
            </ol>`,
        },
        {
          title:
            'Can I stay involved with the family during the executorship process?',
          content: `<p>Yes. The executor handles estate administration. You continue advising the family on new business and investment solutions when the process allows — often during a moment when that support matters most.</p>`,
        },
      ],
    },
    {
      title: 'Registering & getting started',
      faqs: [
        {
          title:
            'How do I register as an adviser on the Old Mutual Will platform?',
          content: `<p>There are two ways to register:</p>
            <ul>
              <li>Go to <a href="/adviser">www.oldmutualwill.co.za/adviser</a> to register online. Complete the sign-up form to create your dedicated adviser account, then start assisting clients.</li>
              <li>OR Email <a href="mailto:adviser@oldmutualwill.co.za">adviser@oldmutualwill.co.za</a> with your adviser/sales code and channel (PFA/IFA/MFC) and request to an adviser account.</li>
            </ul>`,
        },
        {
          title: 'How do I sign up a customer?',
          content: `<p>As an Old Mutual financial adviser, you can help your customers create their wills on the Old Mutual Will platform. The steps are:</p>
            <p><strong>Sign in.</strong> Log in to your adviser profile via oldmutualwill.co.za using your email address and password.</p>
            <p><strong>Create a testator.</strong> Once signed in, click Adviser Dashboard, then Options, followed by Add Testator. Fill in the name and contact fields of the customer / testator, then share the referral link generated via email, SMS or Whatsapp.</p>
            <p><strong>Activate the profile:</strong> They use the link to activate their profile, which remains linked back to you as the adviser.</p>
            <p>From there you can support the client to complete their will.</p>`,
        },
      ],
    },
    {
      title: 'Adviser support',
      faqs: [
        {
          title: 'Where can I get assistance if I need help?',
          content: `<p>Our support team is ready to assist. Contact us at:</p>
            <p><strong>Email:</strong> <a href="mailto:adviser@oldmutualwill.co.za">adviser@oldmutualwill.co.za</a><br />
            <strong>Phone:</strong> 021 753 3248<br />
            <strong>Hours:</strong> Monday – Friday, 08:00 – 17:00</p>`,
        },
      ],
    },
  ],
  sso: {
    googleSsoEnabled: true,
    googleClientId:
      '1093105863552-cgdglv3pp0ieodi3kjpkm8d2vr10s8kp.apps.googleusercontent.com',
    facebookSsoEnabled: true,
    facebookAppId: '484931774122923',
  },
  testamentaryTrustData: [
    {
      title: '<h2>Why Testamentary Trusts Are Important</h2>',
      content: `<p>A testamentary trust is created in your will and activates upon your death. It ensures that your assets 
      are managed according to your wishes, providing financial security for vulnerable beneficiaries like minor children or dependent family members.</p>`,
    },
    {
      title: '<h2>Who Should Consider Setting Up a Testamentary Trust?</h2>',
      content: `<p>If you have minor children, vulnerable family members, or want to ensure your loved ones' inheritance 
      is wisely managed, a testamentary trust is an essential tool in safeguarding their financial future.  
      Setting up a testamentary trust is particularly relevant if you are leaving more than R500 000 to your beneficiaries. </p>`,
    },
    {
      title: '<h2>Purpose and Benefits of a Testamentary Trust</h2>',
      content: `<p>In South Africa, minor children cannot receive inheritance directly. A testamentary trust ensures that their 
      inheritance is managed in their best interests, allowing you to control how and when funds are distributed to your loved ones.</p>`,
    },
    {
      title: '<h2>How Testamentary Trusts Are Established and Managed</h2>',
      content: `<p>A testamentary trust is created through instructions in your will. It only comes into effect after your death, 
      and it’s essential to ensure your will is legally valid to avoid nullifying the trust.</p>`,
    },
    {
      title: '<h2>Appointing a Trustee: What to Consider</h2>',
      content: `<p>The trustee manages the trust’s assets and must act in the best interest of the beneficiaries. 
      Consider appointing an independent trustee to avoid conflicts of interest, especially if the trustee is also the guardian of your children.</p>`,
    },
    {
      title:
        '<h2>Testamentary Trusts in the Old Mutual Will Creation Process</h2>',
      content: `<p>Old Mutual Will offers the option to set up a testamentary trust as part of the online will creation process. 
      This ensures your loved ones are protected in alignment with your wishes.</p>`,
    },
  ],
  executorData: [
    {
      title: '<h2>Understanding the Role of an Executor</h2>',
      content: `<p>An executor is responsible for managing your estate after your passing. Their duties include gathering information about 
      assets and liabilities, paying debts, managing assets, distributing inheritances, and resolving disputes. This role requires a deep understanding of legal and financial matters.</p>`,
    },
    {
      title: '<h2>Why Choosing the Right Executor is Crucial</h2>',
      content: `<p>Selecting the right executor for your estate is vital to ensure that your final wishes are carried out and your loved ones are cared for. 
      An executor needs to be trustworthy, competent, and experienced in estate administration to manage your estate effectively.</p>`,
    },
    {
      title: '<h2>Should You Appoint a Family Member or a Professional?</h2>',
      content: `<p>While appointing a family member may seem logical, estate administration requires expertise that most people lack. 
      The Master of the High Court may require a layperson to hire a professional representative. A professional executor, like Old Mutual, ensures that your estate is managed efficiently and in accordance with legal requirements.</p>`,
    },
    {
      title: '<h2>Executor Fees: What You Need to Know</h2>',
      content: `<p>Executor fees in South Africa are set at 3.5% of the gross value of the estate plus VAT. 
      Executors also charge 6% (plus VAT) of income generated during the administration period. It’s important to ensure that your estate has enough cash flow to cover these costs to avoid selling assets intended for beneficiaries.</p>`,
    },
    {
      title: '<h2>How Old Mutual Can Assist with Executor Services</h2>',
      content: `<p>Old Mutual offers professional executor services, bringing extensive experience in estate administration. 
      They can efficiently handle legal, financial, and administrative tasks, ensuring your estate is managed with care, allowing your family to focus on what matters most during a difficult time.</p>`,
    },
    {
      title:
        '<h2>Planning Ahead with Old Mutual’s Estate Administration Calculator</h2>',
      content: `<p>Old Mutual provides an estate administration costs calculator to help you estimate the costs involved in 
      administering your estate. This tool aids in planning to avoid unnecessary liquidation of assets, ensuring your beneficiaries receive what you intended. 
      Through the steps in this process we will provide you the opportunity to do a detailed cost calculation.</p>`,
    },
    {
      title: '<h2>The Importance of Professional Executor Services</h2>',
      content: `<p>Choosing a professional executor like Old Mutual ensures your estate is managed expertly, safeguarding your legacy 
      and providing peace of mind. Their expertise helps navigate the complexities of estate administration, ensuring your final wishes are honoured.</p>`,
    },
  ],
  livingWillData: [
    {
      title: '<h2>What Is a Living Will?</h2>',
      content: `<p>A Living Will is a legal document that specifies your medical treatment preferences if you become unable to make decisions 
      due to illness or incapacity. It ensures your healthcare choices are respected, even when you can’t communicate them.</p>`,
    },
    {
      title: '<h2>Importance of Creating a Living Will </h2>',
      content: `<p>Creating a Living Will is crucial for ensuring your end-of-life care aligns with your values and preferences. 
      Old Mutual Will offers a straightforward process for creating a Living Will, ensuring your wishes are legally documented and respected.</p>`,
    },
    {
      title: '<h2>Purpose of a Living Will in End-of-Life Planning</h2>',
      content: `<p>The main purpose of a Living Will is to outline your wishes regarding life-sustaining treatments, such as resuscitation or 
      artificial nutrition, in cases of terminal illness or permanent unconsciousness. It provides clear guidance on the medical interventions you do or do not want.</p>`,
    },
    {
      title: '<h2>Legal Standing of Living Wills in South Africa</h2>',
      content: `<p>In South Africa, Living Wills are recognised under common law, meaning they are generally respected by healthcare providers 
      despite not being governed by specific legislation. Clear and specific instructions in your Living Will help avoid ambiguity.</p>`,
    },
    {
      title:
        '<h2>Differences Between a Living Will and a Last Will and Testament</h2>',
      content: `<p>A Living Will specifies your medical treatment preferences if you become incapacitated, focusing on healthcare decisions. 
      A Last Will and Testament, on the other hand, deals with the distribution of your assets and guardianship of minors after your death.</p>`,
    },
    {
      title: '<h2>Why a Living Will Is Important in South Africa</h2>',
      content: `<p>Creating a Living Will is important for ensuring your medical treatment preferences are known, guiding healthcare providers, reducing family conflicts, 
      and bringing peace of mind. It also encourages open discussions about end-of-life care with loved ones.</p>`,
    },
    {
      title: '<h2>How to Create a Living Will in South Africa</h2>',
      content: `<p>To create a Living Will, reflect on your medical preferences, consult healthcare providers if needed.  
      You can then create your Living Will as part of the online process with Old Mutual’s online will creation service.</p>`,
    },
    {
      title: '<h2>Appointing a Healthcare Proxy in South Africa</h2>',
      content: `<p>A healthcare proxy is someone you designate to make medical decisions on your behalf if you’re incapacitated. Choose a responsible 
      person, document the appointment, and ensure they understand your preferences. Formalize this with a power of attorney for healthcare.</p>`,
    },
    {
      title:
        '<h2>Living Will vs. Living Trust: Understanding the Difference</h2>',
      content: `<p>A Living Will outlines your medical preferences if you’re incapacitated, while a Living Trust manages your assets during 
      your lifetime and after death. The Living Will focuses on healthcare, while the Living Trust handles financial matters.</p>`,
    },
    {
      title: '<h2>Living Will vs. Do Not Resuscitate (DNR) Orders</h2>',
      content: `<p>A Living Will covers various medical treatment preferences, including end-of-life care. A DNR order specifically 
      instructs healthcare providers not to perform CPR if your heart stops, focusing on one aspect of your overall medical care plan.</p>`,
    },
  ],
  omDesign: true,
  shippingUserCode: '7357y',
  authentication: {
    login: {
      validation: 'required|email_or_phone',
    },
  },
};
